"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const testUtils_1 = require("../../utils/testUtils");
const withSpacing_1 = __importDefault(require("../../hoc/withSpacing"));
const styles = require('./FormFieldError.module.scss');
const FormFieldError = ({ children, className = '', icon, typeIdPrefix, }) => (react_1.default.createElement("span", Object.assign({ className: (0, classnames_1.default)(styles.error, {
        [className]: !!className,
    }) }, (typeIdPrefix && (0, testUtils_1.getDataTypeAttribute)({ typeId: `${typeIdPrefix}-form-field-error` }))),
    icon && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: styles.icon, icon: icon }),
    children));
exports.default = (0, withSpacing_1.default)(FormFieldError);
//# sourceMappingURL=FormFieldError.js.map